module.exports = __webpack_public_path__ + "static/media/pagos.3832a241.svg";